import React, { useState } from "react";
import PropTypes from "prop-types";
import { MenuItem, Menu, Segment } from "semantic-ui-react";
import { useGetRecords } from "./hooks";
import HomepageRecordsList from "./homepage-records-list";

const HomepageRecords = ({ x }) => {
  const [sort, setSort] = useState("Newest");

  const { data: records, isLoading } = useGetRecords(sort, 3);

  const handleItemClick = (e, { name }) => {
    setSort(name);
  };

  return (
    <div>
      <Menu pointing secondary>
        <MenuItem
          name="Newest"
          active={sort === "Newest"}
          onClick={handleItemClick}
        />
        <MenuItem
          name="Oldest"
          active={sort === "Oldest"}
          onClick={handleItemClick}
        />
      </Menu>
      <Segment
        attached="bottom"
        loading={isLoading}
        basic
        className="borderLess"
      >
        <HomepageRecordsList records={records} isLoading={isLoading} />
      </Segment>
    </div>
  );
};

HomepageRecords.propTypes = {
  x: PropTypes.object,
};

export default HomepageRecords;
